module.exports = __webpack_public_path__ + "static/media/pre_owned_title_zh@2x.9eb95a02.png";